import { render, staticRenderFns } from "./CorporatePayment.vue?vue&type=template&id=1a52dc43&"
import script from "./CorporatePayment.vue?vue&type=script&lang=js&"
export * from "./CorporatePayment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports